import {
    DEALERMULTIPLEMAPPINGLIST_SUCCESS,
    DEALERMULTIPLEMAPPINGLIST_FAILED,
    RESET_DEALERMULTIPLEMAPPINGLIST,
    LOADING_DEALERMULTIPLEMAPPINGLIST,
    NETWORK_ERROR_DEALERMULTIPLEMAPPINGLIST
} from '../types/index'
import { dealerServices } from "../../config/axios";


const resetDealerMultipleMappingList = () => {
    return { type: RESET_DEALERMULTIPLEMAPPINGLIST };
};

const dealerMultipleMappingList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERMULTIPLEMAPPINGLIST });
    await dealerServices
        .post("multipleMappingList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerMultipleMappingListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerMultipleMappingListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERMULTIPLEMAPPINGLIST,
                payload: err
            });
        });
}

function dealerMultipleMappingListsuccess(data) {
    return {
        type: DEALERMULTIPLEMAPPINGLIST_SUCCESS,
        payload: data
    };
}
function dealerMultipleMappingListFailed(data) {
    return {
        type: DEALERMULTIPLEMAPPINGLIST_FAILED,
        payload: data
    };
}

export { resetDealerMultipleMappingList, dealerMultipleMappingList }